import React from 'react';
import { graphql } from 'react-relay';

import BaseLayout from '@zego/layouts/BaseLayout';
import withData from '@zego/lib/withData';
import { interpolateString } from '@zego/utils';
import { clearDup, reloadOTBanner } from '@zego/utils/OneTrustUtils';

import LegalPageLayout from '@zego/components/LegalPageLayout';

import CookiesCopy from './_copy';

const CookiesNl = ({ viewer }) => {
  clearDup();
  reloadOTBanner();

  return (
    <BaseLayout
      viewer={viewer}
      unshiftHeader={false}
      headerIsInitiallyLightOnDark={false}
      title="Cookie Beleid voor Zego"
    >
      <LegalPageLayout
        title="Cookie Beleid voor Zego"
        subtitle="Jouw privacy en veiligheid zijn belangrijk voor ons"
        body={interpolateString(CookiesCopy, viewer.country)}
      />
    </BaseLayout>
  );
};

export default withData(CookiesNl, {
  query: graphql`
    query CookiesNlQuery($country: String!) {
      viewer {
        country: countryByCode(code: $country) {
          supportEmail  
        }
        ...BaseLayout_viewer @arguments(country: $country)
      }
    }
  `,
  getVariables: ({ query }) => {
    return {
      country: query.country,
    };
  },
});
